import { z } from 'zod'

export const paramsSchema = z.object({
  cottageId: z.string().min(1),
  dateIn: z.string(),
  dateOut: z.string(),
  numPeople: z.number().int(),
})

export type paramsType = z.infer<typeof paramsSchema>
